import { CheckIcon } from "lucide-react";

import style from "features/cdm/components/Steps/Steps.module.css";

const Step = ({ step, isActive, isCompleted, index }) => (
  <li className={`${style.step} ${isActive ? style.stepActive : ""}`}>
    {isCompleted ? (
      <div className={style.stepNumberCompleted}>
        <CheckIcon style={{ width: "16px", height: "16px", color: "white" }} />
      </div>
    ) : (
      <div className={`${style.stepNumber} ${isActive ? style.stepNumberActive : ""}`}>
        {index}
      </div>
    )}
    <p className={style.stepName}>{step}</p>
  </li>
);

export const CdmEditSteps = ({ activeStep }) => (
  <ul className={style.stepsWrapper} style={{ gridTemplateColumns: "repeat(6, 1fr)", marginTop: "4px" }}>
    <Step step="Review Setup" isActive={activeStep === 1} isCompleted={activeStep > 1} index={1} />
    <Step step="Review & Exam" isActive={activeStep === 2} isCompleted={activeStep > 2} index={2} />
    <Step step="Tests & Medications" isActive={activeStep === 3} isCompleted={activeStep > 3} index={3} />
    <Step step="Risk & Assessment" isActive={activeStep === 4} isCompleted={activeStep > 4} index={4} />
    <Step step="Vaccinations" isActive={activeStep === 5} isCompleted={activeStep > 5} index={5} />
    <Step step="Care Plan" isActive={activeStep === 6} isCompleted={activeStep > 6} index={6} />
  </ul>
);
